import React, { useState, useEffect } from "react";
import './SupportBanner.scss';
import { getInfoHubHtml } from "../../../utility/common";
import DOMPurify from 'dompurify';
import { Helmet } from 'react-helmet';

const SupportBanner = () =>{

const [bannerHtmlData, setBannerHtmlData] = useState(null);

useEffect(() => {
    let lng = localStorage.getItem("lng");
      getInfoHubHtml(`${global.config.AEM_API_BASE_PATH}/content/experience-fragments/vsbdr/${global.config.aemUrlEnv}/${lng}/customer-support/master.html`).then((response) => {
        setBannerHtmlData(response?.data);
      });
  }, []);
    return (
        <>
      <Helmet>
        <link href={`${global.config.AEM_API_BASE_PATH}${global.config.aemUrlPath}/css/custSupport.css`}
          rel='stylesheet'
          type='text/css'>
        </link>
        <link href={`${global.config.AEM_API_BASE_PATH}${global.config.aemUrlPath}/css/secCrseCard.css`}
          rel='stylesheet'
          type='text/css'>
        </link>
        </Helmet>
      <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(bannerHtmlData) }} />
    </>
    );
}

export default SupportBanner